module.exports = __webpack_public_path__ + "static/media/22861516_1638434389565079_594111357368904551_o.a3ace3c3.jpg";